var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46447 3.00458C6.46447 2.90417 6.42459 2.80787 6.35358 2.73687C6.28258 2.66586 6.18629 2.62598 6.08587 2.62598C5.98546 2.62598 5.88917 2.66586 5.81816 2.73687C5.74716 2.80787 5.70728 2.90417 5.70728 3.00458V5.52857C5.70725 5.59276 5.72354 5.6559 5.75462 5.71206C5.78571 5.76822 5.83056 5.81556 5.88496 5.84962L7.39936 6.79612C7.48451 6.84941 7.58734 6.86668 7.68523 6.84415C7.73369 6.833 7.77949 6.8124 7.82 6.78355C7.86051 6.75469 7.89494 6.71814 7.92132 6.67598C7.94771 6.63382 7.96553 6.58687 7.97377 6.53783C7.98201 6.48878 7.98051 6.43859 7.96936 6.39012C7.9582 6.34165 7.93761 6.29585 7.90875 6.25534C7.87989 6.21483 7.84334 6.1804 7.80118 6.15402L6.46447 5.31858V3.00458Z",
    fill: "#555555"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5.5,
    r: 4.57178,
    stroke: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnClock);
export default __webpack_public_path__ + "static/media/icn_clock.a0f6dec91cb082451b61da5daa4a94ae.svg";
export { ForwardRef as ReactComponent };